<div>
  <button mat-icon-button [matTooltip]="'Global.ManageAccess' | translate" (click)="openShareMenu()">
    <mat-icon>public</mat-icon>
  </button>
</div>
